import React from "react";
import { Text } from "./text";
import { useIsMobile } from "utils/hooks/useIsMobile";

type FormattedDateProps = {
	date?: Date | string;
	sx?: any;
	variant?: "MMM/YYYY" | "DD/MMM" | "DD/MM/YYYY" | "DD/MM/YYYY hh:mm tt" | 'D/MMM/YY';
};

export const FormattedDate: React.FC<FormattedDateProps> = ({ date, variant = "DD/MM/YYYY", sx }) => {
	if (date == null) {
		return null;
	}
	const dateInstance = new Date(date);

	if (variant === "MMM/YYYY") {
		const formattedDate = dateInstance.toLocaleDateString("en-AU", { month: "short", year: "numeric" });

		return <Text sx={sx && sx}>{formattedDate}</Text>;
	}
	if (variant === "DD/MMM") {
		const formattedDate = dateInstance.toLocaleDateString("en-AU", { day: "2-digit", month: "short" });
		return <Text sx={sx && sx}>{formattedDate}</Text>;
	}

	if (variant === "DD/MM/YYYY") {
		const formattedDate = dateInstance.toLocaleDateString("en-AU", { day: "2-digit", month: "2-digit", year: "numeric" });
		return <Text sx={sx && sx}>{formattedDate}</Text>;
	}

	if (variant === "DD/MM/YYYY hh:mm tt") {
		const formattedDate = dateInstance.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" });
		const formattedTime = dateInstance.toLocaleTimeString("en-AU", { hour: "2-digit", minute: "2-digit", hour12: true });
		return <Text sx={sx && sx}>{`${formattedDate} ${formattedTime}`}</Text>;
	}

	if( variant === "D/MMM/YY" )
	{
		const formattedDate = dateInstance.toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "2-digit" });
		return <Text sx={sx && sx}>{formattedDate}</Text>;
	}
};
